// import ReactDOM from "react-dom/client";
// import App from "./App";
// import "./index.scss";
// import reportWebVitals from "./reportWebVitals";
// import { Provider } from "react-redux";
// import Store from "./ReduxToolkit/Store";
// import "./i18n";
// import { unstable_batchedUpdates } from "react-dom";
// import { Component } from "react";
// import {  QueryClientProvider } from "@tanstack/react-query";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
// import { queryClient } from "./Api/queryClient";


// interface Props {
//   children: React.ReactNode;
// }
// unstable_batchedUpdates(() => {
//   console.error = () => {};
// });

// class ErrorBoundary extends Component<Props> {
//   componentDidCatch(error: { message: string | string[] }) {
//     if (error.message.includes("ToastContainer")) {
//       return;
//     }
//   }

//   render() {
//     return this.props.children;
//   }
// }
// const root = ReactDOM.createRoot(
//   document.getElementById("root") as HTMLElement
// );
// root.render(
//   <ErrorBoundary>
//     <Provider store={Store}>
//       <QueryClientProvider client={queryClient}>
//         <App />
//         {/* <ReactQueryDevtools initialIsOpen={false} /> */}
//       </QueryClientProvider>
//     </Provider>
//   </ErrorBoundary>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();


// New Code With Redux persist
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
// 🔥 change: import both Store and persistor
import { Store, persistor } from "./ReduxToolkit/Store";
import "./i18n";
import { unstable_batchedUpdates } from "react-dom";
import { Component } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "./Api/queryClient";
// 🔥 change: import PersistGate
import { PersistGate } from "redux-persist/integration/react";

interface Props {
  children: React.ReactNode;
}
unstable_batchedUpdates(() => {
  console.error = () => {};
});

class ErrorBoundary extends Component<Props> {
  componentDidCatch(error: { message: string | string[] }) {
    if (error.message.includes("ToastContainer")) {
      return;
    }
  }

  render() {
    return this.props.children;
  }
}
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <ErrorBoundary>
    <Provider store={Store}>
      {/* 🔥 change: wrap App with PersistGate */}
      <PersistGate loading={null} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <App />
          {/* <ReactQueryDevtools initialIsOpen={false} /> */}
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
